var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"navbar-config d-middle px-4"},[_c('div',{staticClass:"col-auto px-0 text-general f-18 f-500"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }